<template>
    <div :class="rootClass" ref="rootElement">
        <div>			
            <src-card-list
                id="srcCardList"
                :locale="currentLanguage"
                :card-brands="cardBrands"
                display-add-card="true"
                display-preferred-card="true"
                display-sign-out="true"
                card-selection-type="radioButton"
                src-digital-card-id=""
                display-header="true"
                unaccepted-card-type="DEBIT"
            />
        </div>
    </div>
</template>

<script>
import CardListCss from './CardListCss';

export default {
	components: {},

	mounted() {
		this.initializeCardList(this.cards);
	},

	data() {
		return {
			initialized: false,
			selectedCardBrand: 'mastercard'
		};
	},

	computed: {
		rootClass() {
			// if(!this.cards || this.cards.length === 0) {
			//     return 'card-list-c2p--empty'
			// }
			return 'card-list-c2p';
		},
		cardBrandsText() {
			if (!this.cardBrands || this.cardBrands.length === 0) {
				return '';
			}
			return this.cardBrands.join(', ');
		},
		currentLanguage() {
			const storedLang = localStorage.getItem('vueml-lang') || 'pt-br';
			const langMap = {
				'pt-br': 'pt_BR',
				'en': 'en_US',
				'es-es': 'es_ES'
			};
			return langMap[storedLang] || 'pt_BR';
		}
	},

	watch: {
		cards(value) {
			this.initializeCardList(value);
		}
	},

	props: {
		cardBrands: {
			type: Array,
			default: () => []
		},
		cards: {
			type: Array,
			default() {
				return [];
			}
		},
		locale: {
			type: String,
			default: 'pt_BR'
		},
		selectionType: {
			type: String,
			default: 'radioButton' // ||
		}
	},

	methods: {
		updateSelectedCardBrandBySrcId(srcDigitalCardId) {
			const selectedCard = this.cards.find(
				card => card.srcDigitalCardId === srcDigitalCardId
			);
			if (selectedCard && selectedCard.paymentCardDescriptor) {
				this.selectedCardBrand = selectedCard.paymentCardDescriptor;
			}
		},

		async initializeCardList(maskedCardData) {
			let srcCardListElement = this.$refs.rootElement.querySelector(
				'src-card-list'
			);

			const loadOurStyle = () => {
				const extraSheet = new CSSStyleSheet();
				const shadowElement = document.querySelector('src-card-list')
					.shadowRoot;
				extraSheet.replaceSync(CardListCss);
				shadowElement.adoptedStyleSheets.push(extraSheet);
			};
			if (!this.initialized) {
				// WebComponent pode demorar para carregar.
				await customElements.whenDefined('src-card-list');
				srcCardListElement.addEventListener(
					'selectSrcDigitalCardId',
					event => {
						this.updateSelectedCardBrandBySrcId(event.detail);
						this.$emit('card-selected', event.detail);
					}
				);
				srcCardListElement.addEventListener(
					'clickAddCardLink',
					event => {
						this.$emit('add-card', event.detail);
					}
				);
				srcCardListElement.addEventListener(
					'clickSignOutLink',
					event => {
						this.$emit('sign-out', event.detail);
					}
				);
				this.initialized = true;
			}
			srcCardListElement.loadCards(maskedCardData);
			if (maskedCardData && maskedCardData.length > 0) {
				this.selectedCardBrand = maskedCardData[0].paymentCardDescriptor;
			}
			
			loadOurStyle();
		}
	}
};
</script>

<style lang="css" scoped>
.card-list-c2p--empty {
    display: none;
}

.card-list-c2p {
    margin: auto;
}
</style>
